import { render, staticRenderFns } from "./BusinessGlossaryLoadBulk.vue?vue&type=template&id=4d39ef18&scoped=true&lang=pug"
import script from "./BusinessGlossaryLoadBulk.vue?vue&type=script&lang=js"
export * from "./BusinessGlossaryLoadBulk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d39ef18",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d39ef18')) {
      api.createRecord('4d39ef18', component.options)
    } else {
      api.reload('4d39ef18', component.options)
    }
    module.hot.accept("./BusinessGlossaryLoadBulk.vue?vue&type=template&id=4d39ef18&scoped=true&lang=pug", function () {
      api.rerender('4d39ef18', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/data-platform/modules/business_terms/BusinessGlossaryLoadBulk.vue"
export default component.exports